export default __webpack_public_path__ + "static/media/icon-connections.6662e8cd.svg";